import { render, staticRenderFns } from "./detailFiles.vue?vue&type=template&id=9e38c640&"
import script from "./detailFiles.vue?vue&type=script&lang=js&"
export * from "./detailFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports